/* eslint-disable react/no-array-index-key */
import { Fragment, ReactNode, useCallback, useMemo } from 'react';
import { Skeleton, type SkeletonProps } from '@mantine/core';

import classes from './Skeleton.module.css';

interface MercurySkeletonProps extends SkeletonProps {
  n?: number;
  id?: string;
  renderItem?: (item: ReactNode) => ReactNode;
}

const MercurySkeleton = ({ n = 1, id, renderItem, ...skeletonProps }: MercurySkeletonProps) => {
  const SkeletonComp = useCallback(
    () => <Skeleton classNames={{ root: classes.skeleton }} {...skeletonProps} />,
    []
  );

  if (n === 1) {
    SkeletonComp();
  }

  const placeholders = useMemo(() => [...Array(n || 1)], []);

  return (
    <>
      {placeholders.map((el, i) => (
        <Fragment key={`${id ?? 'skeleton'}-${i}`}>
          {renderItem ? renderItem(SkeletonComp()) : SkeletonComp()}
        </Fragment>
      ))}
    </>
  );
};

export default MercurySkeleton;
